import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ABC from "./images/ABC.png";
import Carousel1 from "./images/carousel1.png";
import Carousel2 from "./images/carousel2.png";
import Carousel3 from "./images/carousel3.png";
import Carousel4 from "./images/carousel4.png";
import Carousel5 from "./images/carousel5.png";
import Carousel6 from "./images/carousel6.png";
import Carousel7 from "./images/carousel7.png";
import Carousel8 from "./images/carousel8.png";
import Carousel9 from "./images/carousel9.png";
import { useMediaQuery } from "react-responsive";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Carousel = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  return (
    <div>
      <bootstrap.Row>
        {!isMobile && <bootstrap.Col></bootstrap.Col>}
        <bootstrap.Col>
          <bootstrap.Carousel data-bs-theme="dark" indicators={false}>
            <bootstrap.Carousel.Item>
              <img className="d-block w-100" src={ABC} alt="ABC" />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel1}
                alt="First slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel2}
                alt="Second slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel3}
                alt="Third slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel4}
                alt="Fourth slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel5}
                alt="Fifth slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel6}
                alt="Sixth slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel7}
                alt="Seventh slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel8}
                alt="Eighth slide"
              />
            </bootstrap.Carousel.Item>
            <bootstrap.Carousel.Item>
              <img
                className="d-block w-100"
                src={Carousel9}
                alt="Nineth slide"
              />
            </bootstrap.Carousel.Item>
          </bootstrap.Carousel>
        </bootstrap.Col>
        {!isMobile && <bootstrap.Col></bootstrap.Col>}
      </bootstrap.Row>
    </div>
  );
};
